/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { Box, Text } from '@components/design-system';

const FormWithNoSSR = dynamic(() => import('./form'), { ssr: false });

export const ContainerPasswordProtection = ({ children }: any) => {
  // if dev do not require. If production check against PASSWORD_PROTECTED
  const requiresPassword = process.env.NODE_ENV === 'development' ? false : process.env.PASSWORD_PROTECTED !== '';
  const [authorised, setAuthorised] = useState(false);
  const [localPass, setLocalPass] = useState('');

  const handleChange = (password: string) => {
    setLocalPass(password);
  };

  const validate = async (password: string) => {
    const response = await fetch('/api/password-protection', {
      body: JSON.stringify({
        password,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    if (response.status === 200) {
      window.localStorage.setItem('versum-secret', password);
      setAuthorised(true);
    }
  };

  useEffect(() => {
    if (requiresPassword) {
      const ls = window.localStorage.getItem('versum-secret');
      if (ls) {
        validate(ls);
      }
    }
  }, []);

  if (requiresPassword && !authorised) {
    return <FormWithNoSSR value={localPass} onChange={handleChange} onValidate={() => validate(localPass)} />;
  }

  return (
    <>
      {children}
      {requiresPassword && (
        <Box css={{ border: '1px dashed $colors$primaryBorder', padding: '$space$4' }} vertical horizontal>
          <Text unset css={{ color: '$secondaryFill', fontSize: 14 }}>
            ⚠️ This url is password protected. Please not not share it or its password with anyone outside the team. ⚠️
          </Text>
        </Box>
      )}
    </>
  );
};
